import { apiClient } from "lib/apiClient";
import { IAssistantPage } from "./getAssistantPages";

export const editAssistantPage = async (
  request: IAssistantPage
): Promise<IAssistantPage> => {
  const response = await apiClient.put(
    `/assistant/pages/${request.code}`,
    request
  );

  return response.data;
};
